module.exports = {"zh":{"word":{"site":"站点管理","createSite":"创建站点"}},"en":{"word":{"site":"Site Management","createSite":"Create a Site"}},"nb":{"word":{"site":"Posisjonsadministrasjon","createSite":"Opprett sted"}},"he":{"word":{"site":"ניהול אתר","createSite":"צור אתר"}},"de":{"word":{"site":"Standortverwaltung","createSite":"Erstellen Sie einen Standort"}}}


//////////////////
// WEBPACK FOOTER
// ./static/i18n/site.json
// module id = jzlu
// module chunks = 25